// extracted by mini-css-extract-plugin
export default {"loading":"PartsViewItem_loading__xW4uk","actionButtons":"PartsViewItem_actionButtons__C5W8y"};